import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil } from "@fortawesome/free-solid-svg-icons";
import { Form } from "react-bootstrap";
import Pagination_Holder from "../../../../../../../../common/common_components/pagination_holder/Pagination_Holder";
import { formatDate } from "../../../../../../../../utils/common";

const Environmental_Report_Table = ({
  setEdit,
  data,
  setCurrentPage,
  currentPage,
}) => {
  const tableData = data?.data || [];

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const perPage = data?.per_page || tableData.length || 0;

  const roomTypes = [
    ...new Set(
      tableData?.flatMap((row) =>
        row.Room_Records?.map((r) => r.Room_Type?.name),
      ),
    ),
  ].filter(Boolean);
  return (
    <>
      <div className="common_table_container theme_bg">
        <div className="table-responsive">
          <table className="common_table table table-striped">
            {/* <thead>
              {" "}
              <tr>
                {" "}
              
                <th rowspan="2">Date</th> <th rowspan="2">Instrument ID</th>{" "}
                <th rowspan="2">Instrument Name</th>{" "}
                <th colspan="2">Lab Room</th> <th colspan="2">Furnace Room</th>{" "}
                <th rowspan="2">Calibration Certificate No</th>{" "}
                <th rowspan="2">Calibration Valid Up To</th>{" "}
              </tr>{" "}
              <tr>
                {" "}
                <th>Temp (°C)</th> <th>RH (%)</th> <th>Temp (°C)</th>{" "}
                <th>RH (%)</th>{" "}
              </tr>{" "}
            </thead>

            <tbody>
              {" "}
              {tableData?.map((row, index) => (
                <tr key={index} className={index % 2 !== 0 ? "striped" : ""}>
                 
                  <td>{formatDate(row.createdAt)}</td> <td>{row.unique_id}</td>{" "}
                  <td>{row.instrument_name}</td> <td>{row.labTemp}</td>{" "}
                  <td>{row.labRH}</td> <td>{row.furnaceTemp}</td>{" "}
                  <td>{row.furnaceRH}</td> <td>{row.certificateNo}</td>{" "}
                  <td>{row.validUntil}</td>{" "}
                </tr>
              ))}{" "}
            </tbody> */}
            <thead>
              <tr>
                <th rowSpan="2">Sr.No</th>
                <th rowSpan="2">Date</th>
                <th rowSpan="2">Instrument ID</th>
                <th rowSpan="2">Instrument Name</th>

                {/* Dynamic room headers */}
                {roomTypes.map((room, i) => (
                  <th key={i} colSpan="2">
                    {room}
                  </th>
                ))}

                <th rowSpan="2">Calibration Certificate No</th>
                <th rowSpan="2">Calibration Valid Up To</th>
              </tr>

              <tr>
                {roomTypes.map((_, i) => (
                  <React.Fragment key={i}>
                    <th>Temp (°C)</th>
                    <th>RH (%)</th>
                  </React.Fragment>
                ))}
              </tr>
            </thead>

            <tbody>
                {tableData && tableData.length > 0 ? (
                  tableData.map((row, index) => {
                    const rooms =
                      row.Room_Records?.reduce((acc, r) => {
                        acc[r.Room_Type?.name] = r;
                        return acc;
                      }, {}) || {};

                    return (
                      <tr key={index}>
                        <td>{(currentPage - 1) * perPage + index + 1}</td>
                        <td>{formatDate(row.createdAt)}</td>
                        <td>{row.unique_id}</td>
                        <td>{row.instrument_name}</td>

                        {/* Dynamic room values */}
                        {roomTypes.map((room, i) => (
                          <React.Fragment key={i}>
                            <td>{rooms[room]?.temp || "-"}</td>
                            <td>{rooms[room]?.rh || "-"}</td>
                          </React.Fragment>
                        ))}

                        <td>{row.calibration_certificate_no}</td>
                        <td>{formatDate(row.next_calibration_due)}</td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td
                      colSpan={4 + roomTypes.length * 2 + 2}
                      style={{ textAlign: "center" }}
                    >
                      No Data Found
                    </td>
                  </tr>
                )}
              </tbody>
          </table>
        </div>
      </div>

      <div className="comon_page_footer">
        <div className="show_entry_div">
          <p className="show_text">
            {" "}
            Showing {tableData.length} of {data?.total || 0} Entries
          </p>
        </div>

        <div className="pagination_div">
          <Pagination_Holder
            onPageChange={currentPage}
            totalPages={data?.total_pages}
            handlePageChange={handlePageChange}
          />
        </div>
      </div>
    </>
  );
};

export default Environmental_Report_Table;
